"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollbarStyles = void 0;
var _core = require("@emotion/core");
var _react = _interopRequireDefault(require("react"));
var _colors = require("../constants/colors");
var _scrollbars = require("../constants/scrollbars");
var _spacing = require("../constants/spacing");
const ScrollbarStyles = () => {
  const styles = (0, _core.css)`
        * {
            scrollbar-color: ${(0, _colors.toRgba)(_colors.neutralDark40, 0.4)} transparent;

            /* set the exact width of the scrollbar */
            &::-webkit-scrollbar {
                width: ${_spacing.sizes.medium}px;
            }

            &::-webkit-scrollbar-track {
                background-color: transparent;
            }

            &::-webkit-scrollbar-corner {
                background: transparent;
            }

            &::-webkit-scrollbar-thumb {
                /* make the thumb appear smaller, half the width of the track */
                border: ${_spacing.sizes.medium / 4}px solid transparent;
                /* round the corners of the thumb */
                border-radius: ${_spacing.sizes.medium / 2}px;
                /* constrain the background color to the padding box */
                background-clip: padding-box;
                /* set the thumb color */
                background-color: ${(0, _colors.toRgba)(_colors.neutralDark40, 0.4)};
                min-height: 40px;
                min-width: 40px;
            }
        }

        /* scrollbar width override for slim styles */
        .${_scrollbars.scrollbarClassNames.slim} {
            scrollbar-width: thin;
            &::-webkit-scrollbar {
                height: ${_spacing.sizes.xSmall}px;
                width: ${_spacing.sizes.xSmall}px;
            }
            &::-webkit-scrollbar-thumb {
                border-width: ${_spacing.sizes.xSmall / 4}px;
                border-radius: ${_spacing.sizes.xSmall / 2}px;
            }
        }
    `;
  return /*#__PURE__*/_react.default.createElement(_core.Global, {
    styles: styles
  });
};
exports.ScrollbarStyles = ScrollbarStyles;
//# sourceMappingURL=ScrollbarStyles.js.map